import React from 'react';
import {useHistory} from "react-router-dom";

export default function withUseHistory(Component) {
    return function (props) {
        const history = useHistory();
        return <Component history={history} {...props}/>;
    };
}
